export default __webpack_public_path__ + "static/media/t43.f654c17f.jpg";